<template>
  <div class="d-flex justify-content-center align-items-center">
    <div>
      <b-button
        variant="secondary"
        class="btn-icon rounded-circle p-3"
        size="sm"
        data-cy="see-events"
        v-on:click="hendleDeleteSuppression()"
      >
        <feather-icon icon="TrashIcon"/>
      </b-button>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  components: {},
  data() {
    return {};
  },
  props: [
    'item'
  ],
  methods: {
    ...mapActions('Emails', [
      'deleteEmailSuppressed'
    ]),
    async hendleDeleteSuppression() {
      await this.deleteEmailSuppressed({ id: this.item.id });
      this.$emit('deleted', { id: this.item.id });
    }
  }
};
</script>
